import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {GnFormItem} from '../json-form/json-form-item/FormItem';
import {NzCheckBoxOptionInterface} from 'ng-zorro-antd/checkbox';

@Component({
  selector: 'gn-checkbox-group',
  template: `
    <nz-checkbox-group [(ngModel)]="items" (ngModelChange)="valueChange(value);valueChanged.emit()"></nz-checkbox-group>
  `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => GnCheckboxGroupComponent),
    multi: true
  }]
})
@GnFormItem('checkbox-group')
export class GnCheckboxGroupComponent implements ControlValueAccessor {

  items: NzCheckBoxOptionInterface[];
  private innerValue: string[];

  @Input() set value(v: any) {
    if (this.innerValue !== v) {
      this.innerValue = v;

      this.items.forEach(item => {
        item.checked = this.innerValue.includes(item.value);
      });

      this.valueChange(this.innerValue);
    }
  }

  get value(): any {
    this.innerValue = this.items.filter(item => item.checked).map(item => item.value);
    return this.innerValue;
  }

  @Output() valueChanged = new EventEmitter();

  valueChange = (value: any) => {
  }

  registerOnChange(fn: any): void {
    this.valueChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

}
